<vdr-card
  *ngIf="!isNew && !freeGifts"
  [title]="'freeGift.freeGifts' | translate"
  class="mb-3"
>
  <vdr-form-field for="additionalOrderNeeded">
    <clr-toggle-wrapper>
      <input
        type="checkbox"
        clrToggle
        name="giftByVariant"
        [formControl]="detailForm.get('customFields.giftByVariant')"
      />
      <label>{{ "freeGift.set-up-by-variant" | translate }}</label>
    </clr-toggle-wrapper>
  </vdr-form-field>
  <ng-container
    *ngIf="
      detailForm.get('customFields.giftByVariant').value; else productGiftForm
    "
  >
    <ng-container
      *ngFor="
        let selectionForm of variantSelectionFormArray.controls;
        index as i
      "
    >
      <vdr-card>
        <form [formGroup]="selectionForm">
          <div class="variant-selection-card-title">
            <div style="font-weight: bold">
              {{ selectionForm.get("name").value }}
            </div>
            <button
              class="btn button-ghost"
              (click)="addCondition(selectionForm.value.id)"
            >
              <clr-icon shape="plus" dir="right"></clr-icon>
              {{ "freeGift.addCondition" | translate }}
            </button>
          </div>

          <div style="display: flex; margin-top: 6px">
            <label
              style="margin-right: 8px; color: #666666"
              [for]="'random' + i"
            >
              {{ "freeGift.random" | translate }}
            </label>
            <input
              [id]="'random' + i"
              type="checkbox"
              clrToggle
              name="enabled"
              [formControl]="selectionForm.get(['isRandom'])"
            />
          </div>

          <div
            style="margin-top: 6px; width: 100%"
            *ngIf="selectionForm.value.isRandom"
          >
            <vdr-form-field
              label="Title"
              [for]="'title' + i"
              style="width: 100%"
            >
              <input
                [id]="'title' + i"
                type="text"
                [formControl]="selectionForm.get(['title'])"
              />
            </vdr-form-field>
          </div>

          <button
            *ngIf="!(selectionForm.pristine || selectionForm.invalid)"
            class="btn btn-primary"
            (click)="saveSelection(selectionForm)"
            style="margin-top: 6px"
          >
            {{ "common.save" | translate }}
          </button>

          <ng-container *ngIf="getConditions(selectionForm) <= 0">
            <div style="text-align: center; margin-top: 1rem">
              {{ "freeGift.noCondition" | translate }}
            </div>
          </ng-container>

          <ng-container *ngFor="let condition of getConditions(selectionForm)">
            <condition-card
              [condition]="condition"
              (refetch)="refresh(productId)"
              [productId]="productId"
              [productName]="productName"
              [detailForm]="detailForm"
            ></condition-card>
          </ng-container>
        </form>
      </vdr-card>
    </ng-container>
  </ng-container>

  <ng-template #productGiftForm>
      <vdr-card>
        <form [formGroup]="productSelectionForm">
          <div class="variant-selection-card-title">
            <div style="font-weight: bold">
              {{ productSelectionForm.get("name").value }}
            </div>
            <button
              class="btn button-ghost"
              (click)="addConditionProduct(productSelectionForm.value.id)"
            >
              <clr-icon shape="plus" dir="right"></clr-icon>
              {{ "freeGift.addCondition" | translate }}
            </button>
          </div>

          <div style="display: flex; margin-top: 6px">
            <label
              style="margin-right: 8px; color: #666666"
              [for]="'random' + i"
            >
              {{ "freeGift.random" | translate }}
            </label>
            <input
              [id]="'random' + i"
              type="checkbox"
              clrToggle
              name="enabled"
              [formControl]="productSelectionForm.get(['isRandom'])"
            />
          </div>

          <div
            style="margin-top: 6px; width: 100%"
            *ngIf="productSelectionForm.value.isRandom"
          >
            <vdr-form-field
              label="Title"
              [for]="'title' + i"
              style="width: 100%"
            >
              <input
                [id]="'title' + i"
                type="text"
                [formControl]="productSelectionForm.get(['title'])"
              />
            </vdr-form-field>
          </div>

          <button
            *ngIf="!(productSelectionForm.pristine || productSelectionForm.invalid)"
            class="btn btn-primary"
            (click)="saveSelection(productSelectionForm)"
            style="margin-top: 6px"
          >
            {{ "common.save" | translate }}
          </button>

          <ng-container *ngIf="getConditions(productSelectionForm) <= 0">
            <div style="text-align: center; margin-top: 1rem">
              {{ "freeGift.noCondition" | translate }}
            </div>
          </ng-container>

          <ng-container *ngFor="let condition of getConditions(productSelectionForm)">
            <condition-card
              [condition]="condition"
              (refetch)="refresh(productId)"
              [productId]="productId"
              [productName]="productName"
            ></condition-card>
          </ng-container>
        </form>
      </vdr-card>
  </ng-template>
</vdr-card>
